import { Stack, Skeleton } from '@mui/material'
import { useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useGetAlbumTracksQuery } from '../../../api/albumApiSlice'
import TrackRow from '../../track/TrackRow'


const AlbumTracks = () => {
    let { id } = useParams()
    const navigate = useNavigate()

    const {
        data: tracks,
        isFetching
    } = useGetAlbumTracksQuery({id})

    const trackSorted = useMemo(() => {
        var sortedTracks = tracks ? tracks.slice() : []
        return sortedTracks.sort((a, b) => a.track.apple_id > b.track.apple_id ? 1 : -1)
    }, [tracks])

    const navigateToTrack = (id) => {
        navigate(`/track/${id}`)
    }

    return (
        <Stack direction={'row'} sx={{overflow: 'hidden', height: '100%', width: '100%'}}>
           <Stack direction={'column'} sx={{overflow: 'scroll', height: '90%', width: '100%', p: 1, m:1}}>
            {
                trackSorted && trackSorted !== null && !isFetching
                ?   
                    trackSorted.map( (track, i) => <TrackRow key={i} track={track.track} index={i} maxProducers={10} fromAlbum={true} onClick={() => navigateToTrack(track.track._id)} />)             
                : 
                    <Skeleton variant="rectangular" width={'90vw'} height={'90vh'} />
            }
            </Stack>
        </Stack>
    )
}

export default AlbumTracks